import * as React from 'react';

import { FormattedHTMLMessage } from 'js/lib/coursera.react-intl';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/degree-home';

const TrackProgressTrialDisclaimerDialog: React.FC = () => {
  const disclaimer = {
    message: _t(
      `In the next few months, we will be conducting a trial to test a new and improved version of the Student Homepage that aims to provide valuable features, empowering you to view your program's full curriculum, track your progress towards graduation, and stay updated on important academic dates and deadlines. <br/><br/> Please note that during this trial period, the experience will not be the same for everyone. The trial is being conducted in stages, and you may see changes on the home page as we are committed to eventually making the improved experience available to all students in the near future.`
    ),
  };

  return (
    <div>
      <React.Fragment>
        <Typography2 component="p" style={{ marginBottom: 'var(--cds-spacing-200)' }}>
          <FormattedHTMLMessage message={disclaimer.message} />
        </Typography2>
      </React.Fragment>
    </div>
  );
};

export default TrackProgressTrialDisclaimerDialog;
